import { axios } from 'Lib/axios'
import { DefaultAccount } from 'Types/LoginResponse'
import { LanguagesTypes } from 'Types/Languages'

type GoogleLoginParamsType = {
  googleToken: string
}

type GoogleSsoLoginResponse = {
  token: string
  authCode: string
  defaultAccount: DefaultAccount
  userId: number
  subscriptionId: number
  language: LanguagesTypes
  multiAccount: boolean
  neverSubscribed: boolean
}

export const googleSsoLogin = async (params: GoogleLoginParamsType) => {
  const response = await axios.post<{ data: GoogleSsoLoginResponse }>(`auth/google`, params)
  return response.data
}
